import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpParams, HttpClient } from '@angular/common/http';

import { environment } from '../../environments/environment';
import { PaystubFilter } from './paystub.filter';
import { requestHeaders, handleError } from '../shared/api.service';

@Injectable()
export class PaystubFilterService {
  baseUrl = environment.serverUrl;
  public nextUris = {};

  constructor(private http: HttpClient) { }

  getFilters(filterType: string, search: string = null): Observable<PaystubFilter[]> {
    let params: HttpParams = new HttpParams();
    params = params.set('page_size', '6');
    if (search) {
      params = params.set('search', search);
    }

    let filtersUrl = this.baseUrl + 'expenses/' + filterType + '/';

    return this.http.get(filtersUrl, {
        headers: requestHeaders(),
        params: params
      }).pipe(
        map(res => { return this.extractData(filterType, res); }),
        catchError(handleError)
      );
  }

  getNext(filterType: string): Observable<PaystubFilter[]> {
     if (this.nextUris[filterType]) {
      return this.http.get(this.nextUris[filterType], {headers: requestHeaders()}).pipe(
        map((res: Response) => { return this.extractData(filterType, res); }),
        catchError(handleError)
      );
    } else {
      return null;
    }
  }

  private extractData(filterType: string, res: Object, condensed = false) {
    let resObj = res;
    this.nextUris[filterType] = resObj['next'];
    let body = resObj['results'];
    if (body) {
      return body.map(filter => {
        return new PaystubFilter(filter);
      });
    } else {
      return { };
    }
  }
}
